












































































import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreFormLookup from '@/components/shared/MStoreFormLookup.vue';
import MStoreFormDatePicker from '@/components/shared/MStoreFormDatePicker.vue';
import { DealDocumentCopyRequestModel } from '@/types';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ObjectHelper } from '@/mixins';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { DealDocumentCopyService } from '@/services';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { DealDocumentCopyListConfigurationModel } from '@/services/GeneratedApi';
import ApiConfiguration from '@/classes/ApiConfiguration';

export default Vue.extend({
  name: 'DealCopyRequest',
  mixins: [FormFieldValidation, ObjectHelper],
  inject: ['$validator'],
  data() {
    return {
      request: {} as DealDocumentCopyRequestModel,
      isLoading: true,
      isSubmitting: false,
      formerStockNumber: '',
      currentStockNumber: '',
      listConfiguration: {} as DealDocumentCopyListConfigurationModel
    };
  },
  methods: {
    async onSubmit(this: any) {
      // Make the API call
      this.isSubmitting = true;
      const dealDocCopyRequest: DealDocumentCopyRequestModel = {
        formerStockNumber: this.formerStockNumber,
        currentStockNumber: this.currentStockNumber
      };
      await DealDocumentCopyService.createDealCopyRequestAsync(dealDocCopyRequest)
        .then(async (response: any) => {
          SnotifyConfiguration.showSuccess('Deal document copy request Submitted successfully.');
          this.isSubmitting = false;
          this.isLoading = false;
        })
        .catch((error) => {
          SnotifyConfiguration.showError('An error occured submitting deal document copy request.');
          this.isSubmitting = false;
          this.isLoading = false;
        });
    },
    onFormerStockRowSelected(this: any, row: any) {
      if (this.isNullOrEmpty(row) || row.length === 0) {
        return;
      }
      this.formerStockNumber = Object.values(row)[0];
    },
    onCurrentStockRowSelected(this: any, row: any) {
      if (this.isNullOrEmpty(row) || row.length === 0) {
        return;
      }
      this.currentStockNumber = Object.values(row)[0];
    }
  },
  computed: {},
  async mounted() {
    try {
      this.listConfiguration = (await ApiConfiguration.api().dealDocument.automotiveDealDocumentGetList()) as DealDocumentCopyListConfigurationModel;
    } catch (error) {
      this.$log('Failed to get deal document configuration: ', error);
    } finally {
      this.isLoading = false;
    }
  },
  components: {
    MStoreFormDatePicker,
    LoadingSpinner,
    MStoreFormSelect,
    MStoreFormLookup,
    MStoreSpinnerButton
  }
});
